import React, { CSSProperties } from 'react';
import classNames from 'classnames';

import { Type } from '@nerdwallet/currency/components/Type';
import { colors } from '@nerdwallet/base-styles/variables';
import WarningIcon from '@nerdwallet/react-icon/material/Error';
import ErrorIcon from '@nerdwallet/react-icon/nerdwallet-ui/Error';

import styles from './error-banner.module.scss';

type ErrorBannerProps = {
  className?: string;
  errorMessage: string | React.ReactNode;
  type?: 'error' | 'warning';
  style?: CSSProperties;
};

const ErrorBanner: React.FC<ErrorBannerProps> = ({
  className,
  errorMessage,
  type = 'error',
  style = {},
  ...props
}) => {
  const isError = type === 'error';
  return (
    <div
      className={classNames(
        isError ? styles.errorContainer : styles.warningContainer,
        className,
      )}
      style={style}
      {...props}
    >
      {isError ? (
        <ErrorIcon color={colors['red-dark']} />
      ) : (
        <WarningIcon color={colors.yellow} size={16} textAligned />
      )}
      <Type error={isError} light size={1}>
        {errorMessage}
      </Type>
    </div>
  );
};

export default ErrorBanner;
